import { gql } from '@apollo/client';

export const EmailNotification = gql`
    mutation emailNotification($active: Boolean!, $email1: String!, $email2: String!, $email3: String!, $agentId: ID!) {
        emailNotification(active: $active, email1: $email1, email2: $email2, email3: $email3, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
